import React, { useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../firebaseConfig";
import { SOCIAL_PLATFORMS } from '../shared/enums';
import { logContactActivity } from '../shared/contactActivityLog';

const socialPlatforms = SOCIAL_PLATFORMS;

const SocialEditModal = ({ isOpen, rowId, initialSocials, onClose, userId, onContactUpdate }) => {
  const [socials, setSocials] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setSocials({ ...(initialSocials || {}) });
    }
  }, [isOpen, initialSocials]);

  if (!isOpen || !rowId) return null;

  const handleSave = async () => {
    if (!userId || !rowId) return;
    setSaving(true);
    try {
      const clean = {};
      Object.entries(socials).forEach(([k, v]) => {
        if (v && v.trim()) clean[k] = v.trim();
      });
      const contactRef = doc(firestore, `World/${userId}/db/${rowId}`);
      const updates = {
        lead_socials: JSON.stringify(clean),
        lead_linkedin: clean.linkedin || '',
        lead_instagram: clean.instagram || '',
        lead_facebook: clean.facebook || '',
        lead_tiktok: clean.tiktok || '',
        lead_twitter: clean.x || '',
        lead_youtube: clean.youtube || '',
        lead_xing: clean.xing || '',
      };
      await updateDoc(contactRef, updates);
      const before = initialSocials || {};
      const changed = socialPlatforms
        .filter((p) => (before[p.key] || '').trim() !== (clean[p.key] || ''))
        .map((p) => p.label || p.key);
      if (changed.length > 0) {
        logContactActivity(firestore, userId, rowId, {
          type: 'edited',
          title: 'Edited: Social profiles',
          detail: changed.join(', '),
        });
      }
      onContactUpdate(rowId, updates);
      onClose();
    } catch (error) {
      console.error('Failed to save socials:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="social-edit-overlay" onClick={onClose}>
      <div className="social-edit-modal" onClick={e => e.stopPropagation()}>
        <div className="social-edit-header">
          <h3><i className="fa fa-share-alt"></i> Social Media</h3>
          <button className="dm-modal-close" onClick={onClose}>
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="social-edit-content">
          {socialPlatforms.map(p => (
            <div key={p.key} className="social-edit-row">
              <div className="social-edit-icon" style={{ color: p.color }}>
                <i className={p.icon}></i>
              </div>
              <input
                type="url"
                placeholder={p.placeholder}
                value={socials[p.key] || ''}
                onChange={e => setSocials(prev => ({ ...prev, [p.key]: e.target.value }))}
              />
              {socials[p.key] && (
                <button
                  className="social-edit-clear"
                  title="Remove"
                  onClick={() => setSocials(prev => {
                    const next = { ...prev };
                    delete next[p.key];
                    return next;
                  })}
                >
                  <i className="fa fa-times"></i>
                </button>
              )}
            </div>
          ))}
        </div>
        <div className="social-edit-footer">
          <button className="dm-form-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="dm-form-save" disabled={saving} onClick={handleSave}>
            {saving ? <><i className="fa fa-spinner fa-spin"></i> Saving...</> : <><i className="fa fa-check"></i> Save</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialEditModal;
